import React from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { sucursalEditSelector } from '../../selectors/sucursalesSelector'
import { instalacionSelector } from '../../selectors/sessionSelector'
import { sagaGetSucursalById, sagaBorrarSucursal, sagaActivarSucursal, sagaSaveSucursal, sagaActualizarSucursal, sagaActualizarSucursalActiva } from '../../reducers/sucursalesReducer/actions'

import SucursalEdit from '../../components/Sucursales/edit'
import SucursalNew from '../../components/Sucursales/new'

const SucursalEditContainer = ({
  sagaGetSucursalById,
  sagaSaveSucursal,
  sagaActualizarSucursal,
  sagaActivarSucursal,
  sagaBorrarSucursal,
  instalacion,
  sucursal,
  match,
  history
}) => {
  const [sucursalEdit, setSucursalEdit] = React.useState({});
  const [sucursalNew, setSucursalNew] = React.useState({});
  const [sucursalCargada, setSucursalCargada] = React.useState(false);

  const [error, setError] = React.useState(undefined);

  const [editDatos, setEditDatos] = React.useState(false);
  const [editSeguridad, setEditSeguridad] = React.useState(false);

  React.useEffect(() => {
    let idSucursal = match.params.idSucursal;
    if (idSucursal === "0") {
      idSucursal = null;
    } else {
      sagaGetSucursalById(parseInt(idSucursal))
    }
  }, [])

  React.useEffect(() => {
    if (sucursal?.idSucursal) {
      setSucursalEdit(sucursal);
      setSucursalCargada(true);
    }
  }, [sucursal]);

  const pathValue = (path, value) => {
    if (path.length === 1) {
      return { [path[0]]: value }
    } else {
      let p = path.pop()
      return { [p]: pathValue(path, value) }
    }
  }

  const valido = (sucursal) => {
    const error = { valido: true };

    const validarCampo = (campo, mensaje) => {
      const valor = (sucursal[campo] || "").trim();
      if (!valor) {
        error[campo] = mensaje;
        error.valido = false;
      }
    };

    validarCampo('nombre', "Debe definir un nombre de sucursal");
    validarCampo('direccion', "Debe definir una dirección");
    validarCampo('telefono', "Debe definir un teléfono");
    validarCampo('whatsapp', "Debe definir un nro de Whatsapp");
    validarCampo('linkUbicacion', "Debe definir el link de GoogleMaps de ubicación de la sucursal");

    if (error.valido) {
      setError(undefined);
      return true;
    } else {
      setError(error);
      return false;
    }
  };

  const getPreSucursal = () => {
    setSucursalEdit(sucursal);
  }

  const handleOnSave = async () => {
    if (valido(sucursalEdit)) {
      sagaActualizarSucursal({ ...sucursalEdit, idInstalacion: instalacion.id })
      setEditDatos(false);
    }
    else if (this.state.error) {
      setEditDatos(true);
    }
  }

  const handleOnActivo = async () => {
    if (sucursalEdit.activo) {
      sagaActivarSucursal(sucursalEdit.idSucursal);
    } else {
      sagaBorrarSucursal(sucursalEdit.idSucursal);
    }
  }

  return (
    <div>
      {!(match.params.idSucursal === "0") ? (
        <SucursalEdit
          sucursal={sucursalEdit}
          sucursalCargada={sucursalCargada}
          error={error}
          handleOnChange={(x) => { setSucursalEdit({ ...sucursalEdit, ...pathValue(x.target.name.split('.').reverse(), x.target.value) }) }}
          handleChangeSwitchActivo={(e) => { setSucursalEdit({ ...sucursalEdit, activo: e.target.checked }) }}
          handleOnEditSucursal={() => { handleOnSave() }}
          handleSucursalActivo={() => { handleOnActivo() }}
          handleOnCancel={() => { setSucursalEdit({}); history.goBack() }}
          getPreSucursal={getPreSucursal}
          editDatos={editDatos}
          editSeguridad={editSeguridad}
          setEditDatos={setEditDatos}
          setEditSeguridad={setEditSeguridad}
        />
      ) : (
        <SucursalNew
          sucursal={sucursalNew}
          error={error}
          handleOnChange={(x) => { setSucursalNew({ ...sucursalNew, ...pathValue(x.target.name.split('.').reverse(), x.target.value) }) }}
          handleOnSaveSucursal={() => {
            if (valido(sucursalNew)) {
              sagaSaveSucursal({ ...sucursalNew, idInstalacion: instalacion.id }, history);
            }
            setSucursalNew({})
          }}
          handleOnCancel={() => { setSucursalNew({}); history.goBack(); }}
        />
      )}
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    sagaGetSucursalById,
    sagaBorrarSucursal,
    sagaActivarSucursal,
    sagaSaveSucursal,
    sagaActualizarSucursal
  }, dispatch)
}

function mapStateToProps(state) {
  return {
    sucursal: sucursalEditSelector(state),
    instalacion: instalacionSelector(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SucursalEditContainer)